import {useQuery} from 'react-query';
import {getProvinces} from '../../../services/province';

const UseGetProvince = () => {
  const {data: provinces, isLoading} = useQuery(['getProvince'], getProvinces, {
    staleTime: Infinity,
    cacheTime: Infinity,
  });
  return {provinces, isLoading};
};

export default UseGetProvince;
